module.exports = __webpack_public_path__ + "img/lfa-logo copy.89330782.png";